import React, { useState, useRef } from 'react';

import './marginbar.css';

const MarginBar = ({ cost, price, budget = 0, margin = 0 }) => {
  const [hover, setHover] = useState(false);
  const [tooltip, setTooltip] = useState({ x: 0, y: 0, value: 0 });
  const barRef = useRef(null);

  let adjustedBudget = 0;
  let overhead = '';
  let breakeven = 0;
  let profit = 0;
  let costPercent = 0;
  let overheadPercent = 0;
  let profitPercent = 0;

  if (budget == 0) {
    overhead = 0;

  }
  else {
    adjustedBudget = budget + budget * (margin / 100);
    overhead = (budget * price / adjustedBudget) - cost;
    breakeven = cost + overhead;
    profit = price - breakeven;
    costPercent = (cost / price) * 100;
    overheadPercent = (overhead / price) * 100;
    profitPercent = profit > 0 ? (profit / price) * 100 : 0;
  }

  const handleMouseMove = (e) => {
    const rect = barRef.current.getBoundingClientRect();
    const relativeX = e.clientX - rect.left;
    const percent = Math.min(Math.max(relativeX / rect.width, 0), 1);
    const currentValue = price * percent;

    setTooltip({
      x: e.clientX + 10,
      y: e.clientY - 30,
      value: currentValue,
    });
  };

  return (
    <div className='marginbar'>
      <div
        ref={barRef}
        className='marginbar_container'
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
        onMouseMove={handleMouseMove}
      >
        <div
          style={{
            background: '#8884d8',
            width: `${costPercent}%`,
            height: '100%',
            float: 'left',
          }}
        />

        <div
          style={{
            background: '#ffc658',
            width: `${overheadPercent}%`,
            height: '100%',
            float: 'left',
          }}
        />

        {profit > 0 && (
          <div
            style={{
              background: '#82ca9d',
              width: `${profitPercent}%`,
              height: '100%',
              float: 'left',
            }}
          />
        )}
      </div>

      {hover && (
        <div
          style={{
            position: 'fixed',
            top: `${tooltip.y}px`,
            left: `${tooltip.x}px`,
            background: '#333',
            color: '#fff',
            padding: '4px 8px',
            borderRadius: '4px',
            fontSize: '12px',
            zIndex: 9999,
            pointerEvents: 'none',
            whiteSpace: 'nowrap',
          }}
        >
          ${tooltip.value.toFixed(3)}
        </div>
      )}

      <div className='margin_summary'>
        <div><strong>Price:</strong> ${price.toFixed(3)}</div>
        <div><strong>Cost:</strong> ${cost.toFixed(3)}</div>
        <div><strong>Overhead:</strong> ${overhead}</div>
        <div><strong>Breakeven:</strong> ${breakeven.toFixed(3)}</div>
        <div><strong>Profit:</strong> ${profit.toFixed(3)}</div>
        <div><strong>Budget:</strong> ${budget.toLocaleString()}</div>
        <div><strong>Adjusted Budget (+{margin}%):</strong> ${adjustedBudget.toLocaleString()}</div>
      </div>
    </div>
  );
};

export default MarginBar;